import { generatePlayerID, log } from "@tumbodash/browserPackages";

let playerId: string | null = null;

function getActiveId(): string | null {
	log.fx("(module/player/getActiveId)");
	playerId = localStorage.getItem("playerId");
	if (playerId === null) localStorage.setItem("playerId", generatePlayerID());
	return playerId;
}

export default getActiveId;
